@if (inline()) {
  <ng-container *ngTemplateOutlet="pickerPanel" />
} @else {
  <span cdkOverlayOrigin #origin="cdkOverlayOrigin"></span>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="true"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="closed.emit()"
    (detach)="closed.emit()">
    <ng-container *ngTemplateOutlet="pickerPanel" />
  </ng-template>
}

<ng-template #pickerPanel>
  <div
    class="inherit"
    [class.border-standard-divider]="!inline()"
    [class.w-60]="!inline()"
    [class.rounded-md]="!inline()"
    [class.border]="!inline()"
    [class.p-3]="!inline()"
    [class.shadow-xl]="!inline()"
    [class.w-full]="inline()"
    data-testid="custom-color-picker">
    <div
      class="saturation-brightness-area relative h-28 w-full cursor-crosshair touch-none overflow-hidden rounded-sm"
      [style.background-color]="hueColor()"
      (pointerdown)="selectSaturationAndBrightness($event)"
      (pointermove)="moveSaturationAndBrightness($event)">
      <span
        class="pointer-events-none absolute size-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow-[0_0_0_1px_#000]"
        [style.left.%]="saturation() * 100"
        [style.top.%]="(1 - brightness()) * 100"></span>
    </div>

    <div class="mt-4 flex items-center gap-4">
      <span
        class="border-standard-divider size-10 shrink-0 rounded-full border"
        [style.background-color]="selectedColor()"></span>
      <div
        class="hue-slider relative h-4 flex-1 cursor-pointer touch-none"
        (pointerdown)="selectHue($event)"
        (pointermove)="moveHue($event)">
        <span
          class="pointer-events-none absolute top-1/2 size-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-black bg-transparent"
          [style.left.%]="(hue() / 360) * 100"></span>
      </div>
    </div>

    <label class="mt-4 block text-base" for="custom-color-picker-hex">
      {{ cmsTextProvider.corporate.hexValue }}
    </label>
    <input
      id="custom-color-picker-hex"
      class="border-input-focus mt-1 h-9 w-full rounded-md border-2 px-2 text-base uppercase outline-none"
      maxlength="7"
      [value]="hexValue()"
      (input)="updateHexValue($event)" />
  </div>
</ng-template>
